import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.css']
})
export class ImageViewComponent implements OnInit {

  @Input()
  ImageList: any[] = [];
  imgPath: string = '';

  constructor() { }

  ngOnInit() {
    if (this.ImageList.length > 0) {
      this.imgPath = this.ImageList[0];
    }
  }

  ViewImage(_path: string) {
    this.imgPath = _path;
  }

  isVideo(path: string): boolean {
    return path.endsWith('.mp4');
  }
}
